import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { LoggerService, OccEndpointsService, normalizeHttpError } from '@spartacus/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { RestoreCartAdapter } from './restore-cart.adapter';

@Injectable({
  providedIn: 'root',
})
export class OccRestoreCartAdapter implements RestoreCartAdapter {
  protected logger = inject(LoggerService);

  constructor(
    private http: HttpClient,
    private occEndpoints: OccEndpointsService
  ) {}

  restoreCart(cartGuid: string): Observable<string> {
    const url = this.occEndpoints.buildUrl('restoreCart', { urlParams: { cartGuid } });
    return this.http
      .post(url, null, { responseType: 'text' })
      .pipe(catchError((error) => throwError(normalizeHttpError(error, this.logger))));
  }
}
